import React from 'react';
import { Modal } from 'react-bootstrap';
import IWebsite from '../../interfaces/IWebsite';
import { BtnSubmit } from '../inputs/btnSubmit';
import InputText from '../inputs/inputText';
import BaseComponent from '../baseComponent';
import ICategory from '../../interfaces/ICategory';
import EditorConvertToHTML from '../others/editorConvertToHTML';

interface IState {
    form: {
        name: string,
        description: string,
    }
    loading: boolean,
}

interface IProps {
    website: IWebsite,
    onHide(): void,
    onCreated(category: ICategory): void,
}

export default class CreateNewCategoryModal extends BaseComponent<IProps, IState> {

    private inputName: React.RefObject<InputText>;

    constructor(props: IProps) {
        super(props);

        this.state = {
            form: {
                name: '',
                description: '',
            },
            loading: false,
        }

        this.inputName = React.createRef();
    }

    handleSubmit() {
        const isValid = this.validateInputs([
            this.inputName,
        ])

        const website = this.props.website;

        if (isValid) {
            this.setState({
                loading: true
            })

            const form = this.state.form;
            this.websitesApiService.createCategory(website.id, form.name, form.description)
                .then(data => {
                    const category = data.records.categories.items[0];

                    if (data.success) {
                        this.props.onCreated(category);
                        this.props.onHide();
                        // history.push(`/websites/${website.id}/categories/${category.id}`);
                    }
                    else {
                        this.setState({
                            loading: false
                        })
                    }                 
                })
        }
    }

    handleChange(value: any, key: string) {
        this.setState({
            form: {
                ...this.state.form,
                [key]: value
            }})
    }

    handleDoNothing() {

    }

    render() {
        const { form, loading } = this.state; 

        return (
            <Modal animation={false} size="lg" centered={true} show onHide={this.handleDoNothing.bind(this)}>
                <Modal.Header closeButton onHide={this.props.onHide.bind(this)}>
                    <Modal.Title>
                        <h5>Vytvořit novou kategorii</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InputText
                        uid="name"
                        ref={this.inputName}
                        label="Název"
                        onChange={this.handleChange.bind(this)}
                        value={form.name}
                        required
                        maxLength={30}
                    />

                    <EditorConvertToHTML
                        uid="description"
                        value={form.description}
                        onChange={this.handleChange.bind(this)}
                    />

                    <BtnSubmit
                        loading={loading}
                        onClick={this.handleSubmit.bind(this)}
                    >
                        Pokračovat  <i className="fas fa-angle-double-right ml-1"></i>
                    </BtnSubmit>
                </Modal.Body>
            </Modal>
        )
    }
}